/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import {dom, DOMRenderProps, useContextProps} from './utils';
import {HeadingContext} from './RSPContexts';
import React, {ForwardedRef, forwardRef, HTMLAttributes} from 'react';

export interface HeadingProps extends HTMLAttributes<HTMLElement>, DOMRenderProps<'h1', undefined> {
  level?: number
}

export const Heading = forwardRef(function Heading(props: HeadingProps, ref: ForwardedRef<HTMLHeadingElement>) {
  [props, ref] = useContextProps(props, ref, HeadingContext);
  let {children, level = 3, className, ...domProps} = props;
  let Element = dom[`h${level}`];

  return (
    <Element {...domProps} ref={ref} className={className ?? 'react-aria-Heading'}>
      {children}
    </Element>
  );
});
